import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import './ViaLogo.css';
import NORMAL_BLACK_CIRCLE_BLUE_M from '../../assets/logo/inspect_normal_black_circle_blue_m.png';
import NORMAL_BLUE_CIRCLE_WHITE_M from '../../assets/logo/inspect_normal_blue_circle_white_m.png';
import REVERSED_BLACK_CIRCLE_WHITE_M from '../../assets/logo/inspect_reversed_black_circle_white_m.png';
import REVERSED_BLUE_CIRCLE_WHITE_M from '../../assets/logo/inspect_reversed_blue_circle_white_m.png';
import REVERSED_WHITE_CIRCLE_BLACK_M from '../../assets/logo/inspect_reversed_white_circle_black_m.png';
import REVERSED_WHITE_CIRCLE_BLUE_M from '../../assets/logo/inspect_reversed_white_circle_blue_m.png';
import MOBLYX_NORMAL_BLUE_CIRCLE_WHITE_M from '../../assets/logo/moblyx_normal_logo_blue_circle_white_m.png';
import MOBLYX_REVERSED_NORMAL_BLUE_CIRCLE_WHITE_M from '../../assets/logo/powered_by (WHITE).png';
import POWERED_NORMAL_MOBLYX_BLUE_CIRCLE_WHITE_M from '../../assets/logo/powered_normal_moblyx_no_strapline_blue_circle.png';
import { isUrlAbsolute } from '../../utility/via-fetch';


export const LogoLocations = Object.freeze({
  /* M-Inspect */
  NORMAL_BLACK_CIRCLE_BLUE_M,
  NORMAL_BLUE_CIRCLE_WHITE_M,
  REVERSED_BLACK_CIRCLE_WHITE_M,
  REVERSED_BLUE_CIRCLE_WHITE_M,
  REVERSED_WHITE_CIRCLE_BLACK_M,
  REVERSED_WHITE_CIRCLE_BLUE_M,

  /* Moblyx */
  MOBLYX_NORMAL_BLUE_CIRCLE_WHITE_M,
  MOBLYX_REVERSED_NORMAL_BLUE_CIRCLE_WHITE_M,
  POWERED_NORMAL_MOBLYX_BLUE_CIRCLE_WHITE_M,
});

export const MoblyxLogoLocations = Object.freeze({

});


function ViaImg({ imgSrc }) {
  const intl = useIntl();

  return (
    <img
      className="via-img"
      src={imgSrc}
      alt={intl.formatMessage({ id: 'platformTitle' })}
    />
  );
}

ViaImg.propTypes = {
  imgSrc: PropTypes.string.isRequired,
};


export function ViaLogo({
  href, logoSrc, style, className,
}) {
  // If there's an href then we want the logo to wrapped in an anchor.
  const Wrapper = useCallback(({ children, ...rest }) => {
    if (href) {
      // Check if the link is going externally. The Link component is only for internal components.
      return isUrlAbsolute(href)
        ? <a href={href} {...rest}>{children}</a>
        : <Link to={href} {...rest}>{children}</Link>;
    }

    return <div {...rest}>{children}</div>;
  }, [href]);

  return (
    <Wrapper style={style} className={`via-logo ${className || ''}`}>
      <ViaImg imgSrc={logoSrc} />
    </Wrapper>
  );
}

ViaLogo.propTypes = {
  href: PropTypes.string,
  logoSrc: PropTypes.string,
  style: PropTypes.shape({}), // Any JS-CSS style. Too many to define in a prop type.
  className: PropTypes.string,
};

ViaLogo.defaultProps = {
  href: undefined,
  logoSrc: LogoLocations.NORMAL_BLUE_CIRCLE_WHITE_M,
  style: undefined,
  className: undefined,
};
